// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e672d06f","396":"cb3ecf08","455":"8266f170","788":"4688c33d","977":"5bca2e4c"}[chunkId] + ".chunk.js";
};